import { apiFetch } from '../../apiFetch'

export const getAdminDungeons = async (params = {}) => {
  const query = new URLSearchParams(params).toString()
  return await apiFetch({
    path: `/admin/dungeons${query ? `?${query}` : ''}`
  })
}

export const getAdminDungeon = async (id) => {
  return await apiFetch({
    path: `/admin/dungeons/${id}`
  })
}

export const createAdminDungeon = async (data) => {
  return await apiFetch({
    path: '/admin/dungeons',
    method: 'POST',
    payload: data
  })
}

export const updateAdminDungeon = async (id, data) => {
  return await apiFetch({
    path: `/admin/dungeons/${id}`,
    method: 'PUT',
    payload: data
  })
}

export const deleteAdminDungeon = async (id) => {
  return await apiFetch({
    path: `/admin/dungeons/${id}`,
    method: 'DELETE'
  })
}
